/**
*    URL DEL SERVER
*/
//export var ipRoot = "https://barter-pagos-mongo.herokuapp.com/";
//export var ipRoot = "http://34.95.181.64:3001/";
export var ipRoot = "https://barter-pagos-mongo.onrender.com/";
//export var ipRoot = "http://localhost:3001/";
export var url = ipRoot+'api/';
export var ip = ipRoot+'api/';

export const url_upload_profile=ipRoot+'api/uploads/usr';
export const url_upload_licences=ipRoot+'api/uploads/usr';
export const url_upload_voices=ipRoot+'api/uploads/usr';
export const url_download_voices=ipRoot+'api/downloads/prod/';
export const url_download=ipRoot+'api/api/downloads/prod/';

/**
 * Metamask
 * data contact testnet token
 * https://testnet.bscscan.com/token/0x1f2231cee838d3fb1d1d0ba78cf5ded32f239e2d#code
 */
export const tokenABI = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
export const addressTokenBarter = "0x1f2231cEe838d3Fb1D1d0BA78cF5Ded32f239E2d";
export const coinTokenBarter = "BARTER";

/**
*  USUARIOS USER
*/
export class Iuser{
    name?: string;
    lastname?: string;
    id_document?: string;
    tel?: string;
    bater_credit?: number;
    bater_debt?: number;
    username?: string;
    email?: string;
    _id?: number|string;
    user_status_id?: number;
    password?:string;
    avatar?:string;
    image?:string;
    realm?:string;
    membership?:Imembership;
    membership_name?:string;
    rating?: Irating;
    address?:string;
    id_coinbase?:string;
    access_token_coinbase_refresh?:string;
    access_token_coinbase?:string;
    id_binance?:string;
    access_token_binance_refresh?:string;
    access_token_binance?:string;
    frase?:string;
    currency_local?:string;
    id_metamask?:string
}
export class Imembership{
    active:boolean;
    available_money:number;
    available_publi:number;
    end_membership:Date;
    _id:number|string;
    idTypeM:string;
    idUser:number;
    number_Order:string;
    start_membership:Date;
    transaction:string;
    typeMember:ItypeMember;
}
export class ItypeMember{
    _id:number|string;
    name:string;
}

export class Icomment{
    comment:string
}

export class Irat {
    ratings? : Irating
}

export class Irating{
    seller : Isb;
    buyer : Isb;
}
export class Isb{
    comment: Iranking[];
    total : number;
    Excelent?: number;
    Good?: number;
    Neutro: number;
    Bad?: number
}
export class Iranking{
    comment?: string;
    image?: string;
    rating: string;
    user?: string;
}
export class Icomments{
    comment?: Imessage[];
    count?: number
}
export class Imessage{
    message?: string;
    date?: string;
}

export class Icountries{
    code: string;
    name: string;
}


export class Icities{
    region: string;
    country: string;
}


export class Iratingfather{
    ratings:Iratings
}

export class Iratings{
    buyer: IratingData;
    seller: IratingData;
    total : number;
}

export class IratingData {
    BAD?: number;
    EXCELLENT?: number;
    GOOD?: number;
    NEUTRO?: number;
    comment?: Icommentss[];
    total?: number;
}

export class Icommentss{
    comment?: string;
    image?: string;
    rating?: string;
    user?: string;
}
/**
*  CHAT
*/
export class ChatMessage {
    touser?:any|UserInfo
    messageId?:number | string;
    userId?: any;
    userName?: string;
    userAvatar?: string;
    toUserId?: number| string;
    time?: number | string;
    status?: string;
    message?: string;
    text?: string;
    chat?:Ichats;
    chat_id?:number | string;
    type?: string;
    voice?: string;
    _id?: number|string;
    read?: boolean;
    filepath?: string;
    hide?:boolean;
    timeStart?:string;
    name?:string;
    tracks?:any;
    deal_status_id?: string | number;
    deal_id?:string;
    username?:string;
    image?:string;
    notification?:string;
    proposal?:Iproposal|any;
}
export class IChat {
    messages: Imessages[] | null;
}

export class Imessages {
   author:string;
  chat_id:number;
  create_time:Date;
    _id:string;
  read:boolean;
  text:string;
  voice?: string;
}

export class UserInfo {
    _id:string;
    name?: string;
    username?: string;
    email?: string;
    image?: string;
    lastname?: string;
    userAvatar?:string;
}

export class Ichat{
    chats:Ichats[];
}
export class Ichats{
    bUsers?: Iuser[];
    proposal?:Iproposal|any;
    deal_id?:number|string;
    _id?:number|string;
    message?:number;
    hide?: boolean| any;
    deal?:Ideal;
    timeStart?: Date|string;
    name?: string;
    username?: string;
    image?: string;
    chat?: string;
    tracks?: [];
    deal_status_id?:string; 
}

export class Ideal{
    deal_status_id?:string;
    proposal?:Iproposal;
}
export class Iproposal{
    _id?:string
    datefinished?:string
    status?:string|boolean              //
    type?: string               //sale | buy
    offered_amount?:number;
    offered_currency_id?:string;
    wanted_amount?:number;
    wanted_currency_id?: string;
    creator_id?:number|string|UserInfo|any;
    limit?: Limit
    bUser?: any
    method?: any | IproposalMethod[]//Efectivo en persona | Bancolombia | Nequi | B Venezuela
    comment?: IproposalComent
    operations?:IproposalOperations[]
}

class IproposalComent {
    positivo: boolean
    text: string
}
export class IproposalMethod {
    _id?: string
    color?:string
    type?:any
    description?:string
    value?:string
    fullname ?:string
    document_id ?:string
    document_type ?:string
    direccion ?:string
    account_number ?:number
    account_type?:string
}

export class IproposalOperations {
    amount: Number
    //es falso cuando es compra por que el usuario que compra puede que pago pero olo le que vende confirma
    status: Boolean
    trafered_other: Boolean
    chat: string
    bUser: string
}
export class Limit {
    from: number
    to: number
    currency?: string
    retricted: boolean
    time?: string
    terminos?: string
}
/**
 * Interfaz para la verfication del deal
 */
export class Iverification{
        deal:IFeedback[];
}
export class IFeedback{
    buyerFeedback:Feedback;
    buyer_feedback_id:number;
    buyer_id:number;
    create_time:Date;
    _id:number|string;/* id del deal*/
    proposal_id:number;
    sellerFeedback:Feedback;
    seller_feedback_id:number;
    seller_id:number;
    update_time:Date;
}
export class Feedback{
    comment:string;
    ended:boolean;
    _id:number|string;
    rating:number;
    recommend:string;
    user_id:number;
}
/**
*        classS DEL WALLET PURSE
*/
export class IpurseMenu{
    coin?:string;
    name?:string;
    description:string;
    status:boolean;
    money?:number;
    available_balance?:number;
    icon?:string;
    image?:string;
    number_account?:string;
    valuta?:string;
    coinId?:CoinId;
    _id?:string;
}
export class CoinId{
    coin?:string;
    _id?:string;
    address_token?:string;
    name?:string;
    description?:string;
    status?:boolean;
    icon?:string;
    image?:string;
    valuta?:string;
    formula?: string
    checked?:Boolean
}
export class Icard{
    error?:any
    number_card?:string;
    name_card?:string;
    date_expiration?:string;
    address?:string;
    email?:string;
    code?:string;
    short_card_number?:string;

    allow_buy?: boolean
    allow_deposit?: boolean
    allow_sell?: boolean
    allow_withdraw?: boolean
    created_at?: string
    currency?: string
    id?: string
    instant_buy?: boolean
    instant_sell?: boolean
    limits?: Limits
    minimum_purchase_amount?: {
        amount: string  
        currency: string
    }
    name?: string
    primary_buy?: boolean
    primary_sell?: boolean
    resource?: string
    resource_path?: string
    type?:string
    updated_at?: string
    verified?: boolean
  }
  interface Limits {
        type: string
        name: string, 
        buy: LBuy[], 
        deposit: Ldeposit[]
  }
  interface Ldeposit {
        "period_in_days": number
        "total": {
            "amount": string
            "currency": string
        } 
        "remaining": {
            "amount": string
            "currency": string 
        } 
        "description": string
        "label": string
  }
  interface LBuy {
    "period_in_days": number
    "total": {
        "amount": string
        "currency": string
    }
    "remaining": {
        "amount": string
        "currency": string
    },
    "description": string
    "label": string
    "next_requirement": {
        "type": string
        "volume": {
            "amount": string
            "currency": string
        } 
        "amount_remaining": {
            "amount": string
            "currency": string
        } 
        "time_after_starting": number
    }
  }
  export class IhistoryT{
    purse:Ipurse;
    detail:Idetail[];
  }
  export class Ipurse{
    account_metamask:string;
    number_account:string;
    coinId:string;
    deferred_balance:string;
    available_balance:string;
    total_balance:string;
    create_date:string;
    update_date:string;
    status:boolean;
    userId:number;
  }
  
  export class Idetail{
    operation: string;
    type:string;
    description:string;
    amount:string|number;
    create_date: Date;
    root_account:string;
    destination_account:string;
    flag:string;
  }
export class ITrans{
    amount:string|number;
    create_date:Date;
    description:string;
    destination_account:string;
    operation:string;
    root_account:string;
    status:string;
    type:string;
}

export class IMenuTranfer{
  title:string;
  subtitle?:string;
  icon:string;
  compot?:string;
  status?:string;
  number_bill?:any; 
}

export class wallet{
  private balance: number;

  getThingy(): number {
    return this.balance;
  }

  setThingy(b:number) {
    this.balance = b;
  }
}

export class Ipaginations {
    "ending_before": any
    "starting_after": any
    "previous_ending_before": any
    "next_starting_after": any
    "limit": number
    "order": string
    "previous_uri": any
    "next_uri": any
}

export class Iwarnings {
    "id": string
    "message": string
    "url": URL
}

export class DataRecovey {
    questionaprove?: string
}

export interface OnboardingFaq {
    id: number;
    type?: string;
    detail?: any | OnboardingFaqDetail[];
    updatedAt: number;
    title?: string;
    open?: boolean;
}

interface OnboardingFaqDetail {
  resource: string;
  paragraphImage?: string;
  paragraphTitle?: string;
  paragraphSubtitle?: string;
  paragraph?: string;
}

export interface Iterminosycondiciones {
  title?:string
  description?:string
}

export interface AbiItem {
    anonymous?: boolean;
    constant?: boolean;
    inputs?: AbiInput[];
    name?: string;
    outputs?: AbiOutput[];
    payable?: boolean;
    stateMutability?: StateMutabilityType;
    type: AbiType;
    gas?: number;
}

export interface AbiInput {
    name: string;
    type: string;
    indexed?: boolean;
	components?: AbiInput[];
    internalType?: string;
}

export interface AbiOutput {
    name: string;
    type: string;
	components?: AbiOutput[];
    internalType?: string;
}

export type StateMutabilityType = 'pure' | 'view' | 'nonpayable' | 'payable';

export type AbiType = 'function' | 'constructor' | 'event' | 'fallback' | 'receive';
